/**
 * Grade scale card shown after finishing a mock exam.
 * Marks the achieved score (模試の結果) on the scale bar.
 */
import { Box } from "@mui/material";
import { FC } from "react";
import { background, black } from "@/theme/colors";
import { rounded, spacing } from "@/theme/variables";
import { MockExamGradeScaleBar } from "@/features/mock-exam/components/grade-guide/MockExamGradeScaleBar";
import { getScalePositionPercent } from "@/features/mock-exam/components/grade-guide/grade-scale.utils";

type TMockExamGradeResultCardProps = {
  /** Raw score points earned in the attempt */
  earnedScore: number;
  /** Raw score points of a perfect result (満点) — must come from the same source as earnedScore */
  totalScore: number;
  /** 合格基準 as a share of 満点, e.g. 70 → 「合格基準: 70%」 */
  passingScorePercentage: number;
};

export const MockExamGradeResultCard: FC<TMockExamGradeResultCardProps> = ({ earnedScore, totalScore, passingScorePercentage }) => {
  const resultPositionPercent = getScalePositionPercent(earnedScore, totalScore);

  return (
    <Box
      sx={{
        p: spacing.sm,
        borderRadius: rounded.sm,
        border: `1px solid ${black[95]}`,
        bgcolor: background.white,
      }}
    >
      <MockExamGradeScaleBar passingScorePercentage={passingScorePercentage} resultPositionPercent={resultPositionPercent} />
    </Box>
  );
};
